"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _report = require("@/api/report");
var _enum = require("@/utils/enum");
var _vuePropertyDecorator = require("vue-property-decorator");
var _moment = _interopRequireDefault(require("moment"));
var ReportDay = /*#__PURE__*/function (_Vue) {
  function ReportDay() {
    var _this;
    (0, _classCallCheck2.default)(this, ReportDay);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ReportDay, [].concat(args));
    (0, _defineProperty2.default)(_this, "date", void 0);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "query", {
      date: (0, _moment.default)().format("YYYY-MM-DD")
    });
    (0, _defineProperty2.default)(_this, "filters", {});
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    return _this;
  }
  (0, _inherits2.default)(ReportDay, _Vue);
  return (0, _createClass2.default)(ReportDay, [{
    key: "watchDate",
    value: function watchDate(data) {
      if (data) {
        this.query.date = data;
        this.fetchData();
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchData();
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;
      this.loading = true;
      _report.reportApi.date((0, _objectSpread2.default)({}, this.query)).then(function (res) {
        _this2.data = res.data;
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }, {
    key: "handleDetail",
    value: function handleDetail(row) {
      this.$router.push({
        path: "/order/index",
        query: {
          staffId: row.staff.id,
          date: this.query.date
        }
      });
    }
  }, {
    key: "getSummaries",
    value: function getSummaries(_ref) {
      var data = _ref.data;
      var sum = [];
      sum[0] = "Total";
      sum[3] = 0; // origin
      sum[4] = 0; // total price
      sum[5] = 0; // profit
      data.forEach(function (element) {
        sum[3] += +element.sumOrigin;
        sum[4] += +element.sumReal;
        sum[5] += element.sumProfit;
      });
      sum[3] = this.$formatNumberVN(sum[3]) + "đ";
      sum[4] = this.$formatNumberVN(sum[4]) + "đ";
      sum[5] = this.$formatNumberVN(sum[5]) + "đ";
      return sum;
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ReportDay.prototype, "date", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("date", {
  immediate: true
})], ReportDay.prototype, "watchDate", null);
ReportDay = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {}
})], ReportDay);
var _default = exports.default = ReportDay;